module.exports = __webpack_public_path__ + "img/diaoyun-operator.65d695c9.png";